/* kk-countdown.js — <kk-countdown data-end="YYYY-MM-DD HH:MM" data-tz="Europe/Berlin" data-expired="hide|zero">
   Renders D / H / M / S boxes ([data-cd-d] … [data-cd-s]) until the deadline, interpreted in the given
   IANA time zone (DST-safe via Intl). When expired: data-expired="hide" hides the closest
   [data-cd-wrap] (or itself) and adds .is-expired; "zero" keeps 00:00:00.
   Used by the announcement-bar countdown block and the main-product promo_deal block. */
(function () {
  function tzOffsetMs(date, tz) {
    var f = new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    var p = {};
    f.formatToParts(date).forEach(function (x) { p[x.type] = x.value; });
    var asUTC = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
    return asUTC - date.getTime();
  }
  function parseInTz(str, tz) {
    var m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(String(str || '').trim());
    if (!m) return NaN;
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], 0);
    var off = tzOffsetMs(new Date(guess), tz);
    var ts = guess - off;
    off = tzOffsetMs(new Date(ts), tz);   // second pass fixes DST-edge cases
    return guess - off;
  }
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  class KKCountdown extends HTMLElement {
    connectedCallback() {
      this.tz = this.getAttribute('data-tz') || 'Europe/Berlin';
      if (!String(this.getAttribute('data-end') || '').trim()) return;   // no deadline = always shown
      this.end = parseInTz(this.getAttribute('data-end'), this.tz);
      this.mode = this.getAttribute('data-expired') || 'hide';
      this.$ = { d: this.querySelector('[data-cd-d]'), h: this.querySelector('[data-cd-h]'), m: this.querySelector('[data-cd-m]'), s: this.querySelector('[data-cd-s]') };
      if (isNaN(this.end)) { this._expire(); return; }
      this._tick = this._tick.bind(this);
      this._tick();
      this._timer = setInterval(this._tick, 1000);
    }
    disconnectedCallback() { clearInterval(this._timer); }
    _expire() {
      clearInterval(this._timer);
      this.classList.add('is-expired');
      if (this.mode === 'hide') {
        var wrap = this.closest('[data-cd-wrap]') || this;
        wrap.setAttribute('hidden', '');
        wrap.classList.add('is-expired');
      }
      this.dispatchEvent(new CustomEvent('kk:countdown:expired', { bubbles: true }));
    }
    _tick() {
      var left = this.end - Date.now();
      if (left <= 0) {
        if (this.$.d) this.$.d.textContent = '0';
        ['h', 'm', 's'].forEach(function (k) { if (this.$[k]) this.$[k].textContent = '00'; }, this);
        this._expire();
        return;
      }
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      if (this.$.d) this.$.d.textContent = String(d);
      if (this.$.h) this.$.h.textContent = pad(h);
      if (this.$.m) this.$.m.textContent = pad(m);
      if (this.$.s) this.$.s.textContent = pad(s);
    }
  }
  if (!customElements.get('kk-countdown')) customElements.define('kk-countdown', KKCountdown);

  /* Sticky announcement bar: publish its live height as --kk-ab-h so the sticky header
     (top: var(--kk-ab-h)) sits right below it; 0 when the bar is gone/hidden. */
  function syncBarHeight() {
    var bar = document.querySelector('.section-announcement');
    var h = bar ? bar.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--kk-ab-h', Math.round(h) + 'px');
  }
  ['DOMContentLoaded', 'load', 'resize', 'kk:countdown:expired'].forEach(function (ev) {
    (ev === 'resize' ? window : document).addEventListener(ev, syncBarHeight);
  });
  syncBarHeight();
})();
